var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"search-sticky-nav flex container-xs bg-white clearfix lg:hidden",style:({ display: 'none', position: _vm.isSticky ? 'sticky' : 'static' })},[_vm._t("default",null,{"updateStickiness":_vm.updateStickiness})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }